import React from 'react'

interface ImageProps {
    src: string | undefined
    alt: string
    className?: string
    width?: number
    height?: number
    loading?: 'lazy' | 'eager'
}

const Image = ({src, alt, className, width, height, loading = 'lazy'}: ImageProps) => {
    const imageSrc = src || 'https://placehold.co/400x400/png'
    return (
        <picture>
            <source type="image/webp" srcSet={imageSrc.replace(/\.(jpg|png)$/i, '.webp')} />
            <source type="image/jpeg" srcSet={imageSrc} />
            <img
                src={imageSrc}
                alt={alt}
                className={className ?? 'w-full h-full object-cover'}
                loading={loading}
                {...(width ? {width} : {})}
                {...(height ? {height} : {})}
            />
        </picture>
    )
}
export default Image
